import { clientsApi } from '@modules/clients/entities/client/api';
import { toast } from '@huspy/forge/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useGetEmailAuthLink = (callbackUrl: string, accountExternalId: string) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['useGetEmailAuthLink', callbackUrl],
    queryFn: () =>
      clientsApi.getEmailAuthLink(callbackUrl, accountExternalId),
    placeholderData: keepPreviousData,
    enabled: false,
    retry: false,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetEmailAuthLink;
